import { yupResolver } from '@hookform/resolvers/yup';
import { FirebaseError } from 'firebase/app';
import { sendPasswordResetEmail } from 'firebase/auth';
import { SubmitHandler, useForm } from 'react-hook-form';
import * as yup from 'yup';

import { getEnv } from '../../config/env';
import { firebaseAuth } from '../../firebase/firebase.service';
import { useToast } from '../../toast/Toast.context';

interface ForgotPasswordInputs {
  email: string;
}

const schema = yup
  .object({
    email: yup.string().trim().email().required("L'email est requis"),
  })
  .required();

export const useForgotPassword = () => {
  const { showToast } = useToast();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ForgotPasswordInputs>({
    resolver: yupResolver(schema),
  });

  const onValid: SubmitHandler<ForgotPasswordInputs> = async (data) => {
    try {
      await sendPasswordResetEmail(firebaseAuth, data.email, {
        url: `${getEnv('REACT_APP_SELF_URL')}/login`,
      });
      showToast({
        type: 'success',
        message: `Email de réinitialisation envoyé à ${data.email}, vérifie ta boite mail !`,
      });
    } catch (err) {
      const error = err as FirebaseError;
      showToast({
        type: 'error',
        message: error.message,
      });
    }
  };
  const onSubmit = handleSubmit(onValid);

  return { register, errors, onSubmit };
};
